// Define root routes that should never have an `href` in breadcrumbs
const routeToIgnore = ["services"];

export const getBreadCrumbs = (path: string, pageName?: string) => {
  const routeWords = path.split("/").filter(Boolean); // Use Boolean as a shorthand to filter out empty parts

  const breadcrumbs = routeWords.map((routeWord, index) => {
    const isLast = index === routeWords.length - 1;
    const formattedTitle =
      routeWord === "e-book"
        ? "eBook"
        : routeWord
            .replace(/-/g, " ")
            .split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
            )
            .join(" ");

    const isIgnoreRoot = routeToIgnore.includes(routeWord) && index === 0;

    return {
      title: isLast && pageName ? pageName : formattedTitle,
      ...(isLast || isIgnoreRoot
        ? {}
        : { href: `/${routeWords.slice(0, index + 1).join("/")}` }),
    };
  });

  // Prepend the "Home" breadcrumb
  breadcrumbs.unshift({ title: "Home", href: "/" });

  return breadcrumbs;
};
